/**
 * Truncate Read More Component
 *
 * Handles text truncation with a read more button that expands the full content.
 * Similar structure to secondary-nav component.
 *
 * @component TruncateReadMore
 * @extends HTMLElement
 *
 * @example
 * <truncate-read-more data-read-more-text='...Read More'>
 *   <div class='visually-hidden' data-original-content>
 *     Original content here
 *   </div>
 *   <div class='rte' data-output>
 *     Truncated content here
 *   </div>
 * </truncate-read-more>
 */
function doTruncateReadMore() {
  if (customElements.get('truncate-read-more')) return

  class TruncateReadMore extends HTMLElement {
    constructor() {
      super()

      this.originalContent = this.querySelector('[data-original-content]')
      this.outputContent = this.querySelector('[data-output]')
      this.readMoreText = this.dataset.readMoreText || '...Read More'

      if (!this.originalContent || !this.outputContent) return

      this.init()
    }

    init() {
      // Find the read more button in the output content
      this.readMoreBtn = this.outputContent.querySelector('.read-more-btn')

      if (!this.readMoreBtn) return

      this.readMoreBtn.addEventListener('click', () => {
        // Replace the truncated content with the original content
        this.outputContent.innerHTML = this.originalContent.innerHTML
        this.readMoreBtn.classList.add('hide')
      })
    }
  }

  customElements.define('truncate-read-more', TruncateReadMore)
}

doTruncateReadMore()
